import React, { FC } from 'react'
import { BounceContainer } from '@components/BounceContainer/BounceContainer'
import { Avatar, ListItem, ListItemAvatar, ListItemText, Stack } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from '@utils/routes'
import { format } from 'date-fns'
import { BsArrowReturnRight } from 'react-icons/bs'
import { useTranslation } from 'react-i18next'
import { ExchangeActivity, ExchangeProvider } from '@plug-core/interfaces/transactionActivity'

interface Props {
  exchange: ExchangeActivity
}

const ExchangeListItem: FC<Props> = ({ exchange }) => {
  const navigate = useNavigate()

  const { t } = useTranslation()

  return (
    <BounceContainer>
      <ListItem
        onClick={() =>
          exchange.provider === ExchangeProvider.StealthEx &&
          navigate(ROUTES.CONVERT_RESULT, {
            state: { id: exchange.exchangeId },
          })
        }
      >
        <ListItemAvatar>
          <Avatar sx={{ width: 20, height: 20 }} src={exchange.fromToken.logo} />
          <Stack direction="row" ml={1} alignItems="center">
            <BsArrowReturnRight color="white" />
            <Avatar sx={{ width: 20, height: 20, marginLeft: '5px' }} src={exchange.toToken.logo} />
          </Stack>
        </ListItemAvatar>
        <ListItemText
          primary={
            exchange.provider === ExchangeProvider.StealthEx
              ? t('exchangeRow.converted')
              : t('exchangeRow.swapped')
          }
          secondary={`${format(exchange.timestamp, 'dd MMM')} on ${exchange.provider} `}
          secondaryTypographyProps={{ fontSize: 13, fontWeight: 400 }}
        />
        <ListItemText
          primaryTypographyProps={{
            textAlign: 'right',
            fontSize: 13,
            fontWeight: 400,
          }}
          secondaryTypographyProps={{
            textAlign: 'right',
            fontSize: 13,
            fontWeight: 400,
          }}
          primary={exchange.toAmount}
          secondary={
            exchange.provider === ExchangeProvider.StealthEx
              ? exchange.toToken.symbol.toUpperCase()
              : exchange.toToken.symbol
          }
        />
      </ListItem>
    </BounceContainer>
  )
}

export default ExchangeListItem
